import React, {useCallback, useContext, useEffect, useReducer, useState} from 'react';
import {ContattaciStyle} from "../../styles/pages/contact/ContattaciStyle";
import {
    Avatar,
    Button,
    Card,
    CardActionArea,
    CardHeader,
    CircularProgress,
    Menu,
    MenuItem,
    Paper,
    TextField,
    Typography
} from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import SearchTwoToneIcon from "@mui/icons-material/SearchTwoTone";
import {useHistory, useParams} from "react-router-dom";
import {searchFaq} from "../../services/FaqServices";
import {FAQ_INITIAL_STATE, FaqReducer, initFaqState} from "../../reducers/FaqReducer";
import AccordionFaq from "../gestione/faq/AccordionFaq";
import {getCategoryByLabel} from "../../utils/GenericUtils";
import {BaseStyle} from "../../styles/shared/BaseStyle";
import clsx from 'clsx';
import Grid from "@mui/material/Grid";
import ForumTwoToneIcon from "@mui/icons-material/ForumTwoTone";
import ArrowBackTwoToneIcon from "@mui/icons-material/ArrowBackTwoTone";
import {setLang, setThemeType} from "../../services/AppServices";
import Brightness4TwoToneIcon from "@mui/icons-material/Brightness4TwoTone";
import Brightness5TwoToneIcon from "@mui/icons-material/Brightness5TwoTone";
import {AppContext, CategoriesContext} from "../../App";
import Copyright from "../auth/utils/Copyright";
import {langDict, languages} from "../../strings/LanguageDictionary";
import GTranslateTwoToneIcon from "@mui/icons-material/GTranslateTwoTone";
import useBackgroundImage from "../../styles/hooks/UseNewBackground";


const CategoryPage = () => {
    const [faqState, faqDispatch] = useReducer(FaqReducer, FAQ_INITIAL_STATE, initFaqState);
    const [value, setValue] = useState("");
    let history = useHistory();
    let {categoria} = useParams();
    const contattaciClasses = ContattaciStyle();
    const classes = BaseStyle();
    const appContext = useContext(AppContext);
    const categoriesContext = useContext(CategoriesContext);

    const [anchorEl, setAnchorEl] = useState(null);

    useBackgroundImage();


    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (key) => {
        if (key) {
            setLang(key, appContext.dispatch)
        }
        setAnchorEl(null);
    };

    useEffect(() => {
        searchFaq({}, faqDispatch);
    }, [faqDispatch]);

    const goToHome = useCallback(() => {
        history.push("/contattaci");
    }, [history])

    const goToTicket = useCallback(() => {
        history.push("/contattaci/" + categoria + "/ticket");
    }, [history, categoria])

    const goToTicketCall = useCallback(() => {
        history.push("/contattaci/" + categoria + "/call");
    }, [history, categoria])


    return (
        <React.Fragment>
            <main className={classes.mainNoBgCol}>
                <header className={contattaciClasses.header}>
                    <Tooltip
                        title={appContext.state.theme.palette.mode === "light" ? languages[appContext.state.lang].OCEAN__MAIN_GLOBAL_THEMA_TEXT : languages[appContext.state.lang].OCEAN__GLOBAL_THEMA_TEXT_DARK}>
                        <IconButton
                            className={contattaciClasses.icon}
                            color="inherit"
                            style={{color: appContext.state.theme.palette.mode !== "light" ? "#FFF" : "#000"}}
                            onClick={() => setThemeType(appContext.state.theme.palette.mode === "light" ? "dark" : "light",
                                appContext.state.theme, appContext.dispatch)}
                            size="large">
                            {
                                appContext.state.theme.palette.mode === "light" ?
                                    <Brightness4TwoToneIcon/> :
                                    <Brightness5TwoToneIcon/>
                            }
                        </IconButton>
                    </Tooltip>
                    <Tooltip title={languages[appContext.state.lang].CONTATTACI_CHANGE_LANG_BUTTON}>
                        <Button
                            className={contattaciClasses.translateButton}
                            color="inherit"
                            style={{
                                color: appContext.state.theme.palette.mode !== "light" ? "#FFF" : "#000",
                                borderRadius: 24
                            }}
                            onClick={handleClick}
                            startIcon={<GTranslateTwoToneIcon/>}
                        >
                            {languages[appContext.state.lang].CONTATTACI_CHANGE_LANG_BUTTON}
                        </Button>
                    </Tooltip>
                    <Menu
                        PaperProps={{
                            className: clsx(classes.roundBorder, classes.transparent, classes.blurred20, classes.shadow24)
                        }}
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={() => handleClose()}
                    >
                        {
                            Object.entries(langDict).map(([key, val]) => {
                                return (
                                    <MenuItem style={{width: 300}} key={key} onClick={() => handleClose(key)}>{val.flag}<span
                                        style={{paddingLeft: 8}}>{val.label}</span></MenuItem>
                                )
                            })
                        }
                    </Menu>
                    <Typography variant={"h2"} component={"h1"} className={contattaciClasses.title}>
                        <b>{getCategoryByLabel(categoria, categoriesContext.categoriesV3)?.label}</b>
                    </Typography>
                </header>
                <article className={contattaciClasses.article}>
                    <Paper
                        className={clsx(contattaciClasses.searchBar, classes.roundBorder, classes.transparent80, classes.blurred20)}
                        component={"section"}>
                        <TextField
                            placeholder={languages[appContext.state.lang].CONTATTACI_DESCR_PROBL_INPUT_}
                            value={value}
                            onChange={(e) => setValue(e.target.value)}
                            autoFocus={false}
                            fullWidth={true}
                            variant={"outlined"}
                            InputProps={{
                                startAdornment: <InputAdornment position="start">
                                    <Tooltip title={languages[appContext.state.lang].OCEAN__GLOBAL_SEARCH_MAINTEXT}>
                                        <IconButton color="inherit" size="large">
                                            <SearchTwoToneIcon/>
                                        </IconButton>
                                    </Tooltip>
                                </InputAdornment>,
                                classes: {notchedOutline: contattaciClasses.noBorder}
                            }}
                        />
                    </Paper>
                    {
                        value !== "" ?
                            faqState.loadingSearchFaq ? <CircularProgress style={{marginTop: 50, marginBottom: 50}}/> :
                                faqState.errorSearchFaq !== "" ? "Ops, c'è stato un errore, effettua un refresh della pagina..." :
                                    <section className={clsx(contattaciClasses.cardContainer, classes.faqDetails)}>
                                        {
                                            faqState.faqs?.filter(item => value?.split(" ").filter(wordLength => wordLength.length >= 3)
                                                .some(word => item?.keywords?.split(",").filter(wordItemLength => wordItemLength.length >= 3)
                                                        .some(tag => word.toUpperCase().includes(tag.toUpperCase()) || tag.toUpperCase().includes(word.toUpperCase())) ||
                                                    item?.domanda?.split(" ").filter(wordQuestionLength => wordQuestionLength.length >= 3)
                                                        .some(tag => word.toUpperCase().includes(tag.toUpperCase()) || tag.toUpperCase().includes(word.toUpperCase()))))
                                                .map((val, key) => {
                                                    return (
                                                        <AccordionFaq key={key} risposta={val.risposta}
                                                                      domanda={val.domanda} contattaci={true}/>
                                                    )
                                                })
                                        }
                                    </section> :
                            faqState.loadingSearchFaq ? <CircularProgress style={{marginTop: 50, marginBottom: 50}}/> :
                                faqState.errorSearchFaq !== "" ? "Ops, c'è stato un errore, effettua un refresh della pagina..." :
                                    <section className={clsx(contattaciClasses.cardContainer, classes.faqDetails)}>
                                        {
                                            faqState.faqs?.filter(item => item.categoria?.toLowerCase().replaceAll(" ", "_").replaceAll("-", "_").replaceAll("/", "_").replaceAll("à", "a").replaceAll("(", "_").replaceAll(")", "_") === categoria).map((val, key) => {
                                                return (
                                                    <AccordionFaq key={key} risposta={val.risposta}
                                                                  domanda={val.domanda} contattaci={true}/>
                                                )
                                            })
                                        }
                                        <Paper
                                            className={clsx(classes.roundBorder, contattaciClasses.paperTicketCall, classes.transparent80, classes.blurred20)}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12}>
                                                    <Typography variant={"subtitle1"}
                                                                className={contattaciClasses.paperHeader}>
                                                        <b>{languages[appContext.state.lang].CONTATTACI_LINK__UTILI__TEXT_}:
                                                            <span
                                                                style={{color: appContext.state.theme.palette.primary.main}}>
																{" " + getCategoryByLabel(categoria, categoriesContext.categoriesV3).label}
															</span>
                                                        </b>
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <ul>
                                                        {
                                                            getCategoryByLabel(categoria, categoriesContext.categoriesV3)?.links?.map((link) => {
                                                                return (
                                                                    <li key={link.id} style={{paddingBottom: 8}}>
                                                                        <Tooltip
                                                                            title={languages[appContext.state.lang].CONTATTACI_LINK_UTILI_TOOLTIP}>
                                                                            <Typography noWrap={true}
                                                                                        style={{cursor: "pointer"}}
                                                                                        onClick={() => window.open(link.url, '_blank')}
                                                                                        color={"primary"}>{link.url}</Typography>
                                                                        </Tooltip>
                                                                    </li>
                                                                )
                                                            })
                                                        }
                                                    </ul>
                                                </Grid>
                                            </Grid>
                                        </Paper>
                                        <Paper
                                            className={clsx(classes.roundBorder, contattaciClasses.paperTicketCall, classes.transparent80, classes.blurred20)}>
                                            <Grid container spacing={2} style={{padding: 16}}>
                                                <Grid item xs={12}>
                                                    <Typography className={classes.heading}>
                                                        <b>{languages[appContext.state.lang].CONTATTACI__NEED__MORE__HELP_}</b>
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Typography color={"textSecondary"}>
                                                        {languages[appContext.state.lang].CONTATTACI__TRY__THIS__ALTERN}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12} sm={12}>
                                                    <Tooltip
                                                        title={languages[appContext.state.lang].CONTATTACI_TOOLTIP_RESPO_TEXT}>
                                                        <Card
                                                            className={clsx(classes.roundBorder, classes.transparent80, classes.blurred20)}>
                                                            <CardActionArea onClick={goToTicket}>
                                                                <CardHeader
                                                                    avatar={
                                                                        <Avatar className={classes.blue}>
                                                                            <ForumTwoToneIcon/>
                                                                        </Avatar>
                                                                    }
                                                                    title={
                                                                        <b>{languages[appContext.state.lang].CONTATTACI_OPEN__TICKET__FORM}</b>}
                                                                    subheader={languages[appContext.state.lang].CONTATTACI_OPEN_TICKET_SUBTEX}
                                                                />
                                                            </CardActionArea>
                                                        </Card>
                                                    </Tooltip>

                                                </Grid>
                                                {/*<Grid item xs={12} sm={6}>*/}
                                                {/*    <Tooltip*/}
                                                {/*        title={languages[appContext.state.lang].CONTATTACI_TOOLTIP_RESPO_TEXT}>*/}
                                                {/*        <Card*/}
                                                {/*            className={clsx(classes.roundBorder, classes.transparent10, classes.blurred20)}>*/}
                                                {/*            <CardActionArea onClick={goToTicketCall}>*/}
                                                {/*                <CardHeader*/}
                                                {/*                    avatar={*/}
                                                {/*                        <Avatar className={classes.blue}>*/}
                                                {/*                            <PhoneCallbackTwoToneIcon/>*/}
                                                {/*                        </Avatar>*/}
                                                {/*                    }*/}
                                                {/*                    title={*/}
                                                {/*                        <b>{languages[appContext.state.lang].CONTATTACI__RICEVI__CHIAMATA_}</b>}*/}
                                                {/*                    subheader={languages[appContext.state.lang].CONTATTACI__RICEVI__SUBT_CALL}*/}
                                                {/*                />*/}
                                                {/*            </CardActionArea>*/}
                                                {/*        </Card>*/}
                                                {/*    </Tooltip>*/}
                                                {/*</Grid>*/}
                                            </Grid>
                                        </Paper>
                                    </section>
                    }
                    <Button
                        className={clsx(classes.roundBorder, classes.margin2, classes.blurred20)}
                        style={{borderRadius: 24}}
                        size={"small"} variant={"contained"} color={"primary"}
                        startIcon={<ArrowBackTwoToneIcon/>} onClick={goToHome}>
                        {languages[appContext.state.lang].CONTATTACI_RETURN_HOME_BUTTON}
                    </Button>
                </article>
            </main>
            <footer style={{marginTop: "8%", display: "flex", flexDirection: "column"}}>
                <Copyright/>
            </footer>
        </React.Fragment>
    );
};

export default React.memo(CategoryPage);
